<!-- #region Title -->
<div class="row">
  <div class="col-12 d-flex justify-content-center">
    <h2>Weld Logs</h2>
  </div>
</div>
<!-- #endregion -->

<!-- #region Action Bar -->
<div class="row">
  <div class="col-12">
    <div class="row filter-controls-row">
      <!-- #region Division -->
      <div class="col-1 filter-cell">
        <h6>Divisions</h6>
        <p-select
          name="divisionFilter"
          (onChange)="getUnits(); checkForInactiveFilters()"
          [options]="dropdownService.divisions.items"
          optionLabel="name"
          optionValue="id"
          [(ngModel)]="filterParams.divisionid"
          placeholder="Select"
          [showClear]="true"
          [filter]="true"
          [ngClass]="{ 'pending-filter-drp': filterParams.divisionid != activeFilterParams.divisionid }"
        ></p-select>
      </div>
      <!-- #endregion Division -->

      <!-- #region Units -->
      <div class="col-2 filter-cell">
        <h6>Units</h6>
        <p-select
          name="unitFilter"
          (onChange)="checkForInactiveFilters()"
          [options]="dropdownService.units.items"
          optionLabel="name"
          optionValue="id"
          [(ngModel)]="filterParams.unitid"
          placeholder="Select a Unit"
          [showClear]="true"
          [filter]="true"
          [ngClass]="{ 'pending-filter-drp': filterParams.unitid != activeFilterParams.unitid }"
        ></p-select>
      </div>
      <!-- #endregion Units -->

      <!-- #region Groups -->
      <div class="col-1 filter-cell">
        <h6>Groups</h6>
        <p-select
          name="groupFilter"
          (onChange)="checkForInactiveFilters()"
          [options]="dropdownService.WeldGroups.items"
          optionLabel="name"
          optionValue="id"
          [(ngModel)]="filterParams.groupid"
          placeholder="Select"
          [showClear]="true"
          [filter]="true"
          [ngClass]="{ 'pending-filter-drp': filterParams.groupid != activeFilterParams.groupid }"
        ></p-select>
      </div>
      <!-- #endregion Groups -->

      <!-- #region Date Welded From -->
      <div class="col-2 filter-cell">
        <h6>Date welded from</h6>
        <p-datepicker
          name="weldfromdateFilter"
          inputId="basic"
          (onSelect)="checkForInactiveFilters()"
          [(ngModel)]="filterParams.weldfromdate"
          [showTime]="false"
          dataType="string"
          dateFormat="yy-mm-dd"
          [readonlyInput]="true"
          [ngClass]="{ 'pending-filter-cal': filterParams.weldfromdate != activeFilterParams.weldfromdate }"
        ></p-datepicker>
      </div>
      <!-- #endregion Date Welded From -->

      <!-- #region Date Welded To -->
      <div class="col-2 filter-cell">
        <h6>To</h6>
        <p-datepicker
          name="weldtodateFilter"
          #weldtodate
          inputId="basic"
          (onSelect)="checkForInactiveFilters()"
          [(ngModel)]="filterParams.weldtodate"
          [showTime]="false"
          dataType="string"
          dateFormat="yy-mm-dd"
          [readonlyInput]="true"
          [ngClass]="{ 'pending-filter-cal': filterParams.weldtodate != activeFilterParams.weldtodate }"
        ></p-datepicker>
      </div>
      <!-- #endregion Date Welded To -->

      <!-- #region Stamp IDs -->
      <div class="col-2 filter-cell">
        <h6>Stamp IDs</h6>
        <span [ngClass]="{ 'pending-filter-input': filterParams.stampids != activeFilterParams.stampids }">
          <input type="text" pInputText class="w100" (input)="checkForInactiveFilters()" [(ngModel)]="filterParams.stampids" />
        </span>
      </div>
      <!-- #endregion Stamp IDs -->

      <!-- #region EWO -->
      <div class="col-2 filter-cell">
        <h6>EWO</h6>
        <span [ngClass]="{ 'pending-filter-input': filterParams.ewoNumbers != activeFilterParams.ewoNumbers }">
          <input
            type="text"
            pInputText
            class="w100"
            (input)="checkForInactiveFilters()"
            [(ngModel)]="filterParams.ewoNumbers"
            [ngClass]="{ 'pending-filter-input': filterParams.ewoNumbers != activeFilterParams.ewoNumbers }"
          />
        </span>
      </div>
      <!-- #endregion EWO -->
    </div>
  </div>

  <div class="col-12">
    <div class="row action-buttons-row">
      <!-- #region 'Filter, Customize, Add' -->
      <div class="col-auto">
        <p-button styleClass="p-button-m mt-2 mr-3" (click)="exportToExcel()"><em class="pi pi-file-excel mr-2"></em>Export to Excel</p-button>
      </div>
      <!-- #region Upload Weld Map -->
      <div class="col-auto">
        @if (createLogPermission) {
          <p-button class="upload-weld-map-btn" styleClass="p-button-m mt-2 mr-3" (onClick)="openUploadWeldMapDialog()"> <em class="pi pi-upload mr-2"></em>Upload Weld Map </p-button>
        }
      </div>
      <!-- #endregion Upload Weld Map -->
      <div class="col alignRight">
        <!-- #region Filter Weld Log -->
        <p-button styleClass="p-button-m mt-2 mr-3" [ngClass]="{ 'inactive-filter-btn': inactiveFilters }" (onClick)="submitFilter()"><em class="pi pi-filter mr-2"></em> Filter Weld Logs</p-button>
        <!-- #endregion Filter Weld Log -->

        <!-- #region Customize Table View -->
        <p-button styleClass="p-button-m mt-2 mr-3" (onClick)="openCustomizeTableView()"><em class="pi pi-table mr-2"></em> Customize Table</p-button>
        <!-- #endregion Customize Table View -->

        <!-- #region Add Weld Log -->
        @if (createLogPermission) {
          <p-button class="green-btn" styleClass="p-button-m mt-2 mr-3" (onClick)="newLogOpen()"><em class="pi pi-plus-circle mr-2"></em> Add Weld Log</p-button>
        }
        <!-- #endregion Add Weld Log -->

        <!-- #region Upload Bulk Weld Log -->
        @if (createLogPermission) {
          <p-button class="green-btn" styleClass="p-button-m mt-2 " (onClick)="uploadBulkLogs()" [disabled]="bulkUploadBtnDisabled"
            ><em class="pi pi-cloud-upload mr-2"></em> Bulk Upload Weld Logs {{ bulkUploadBtnDisabled ? bulkUploadBtnTextWhenDisabled : '' }}</p-button
          >
        }
        <!-- #endregion Upload Bulk Weld Log -->
      </div>
      <!-- #endregion 'Filter, Customize, Add' -->
    </div>
  </div>
</div>
<!-- #endregion Action Bar -->

<!-- #region Customize view dialog -->
<p-dialog header="Customize View" [(visible)]="displayCustomizeTableView" [modal]="true" [draggable]="false" [resizable]="false" [closable]="false" [blockScroll]="false" class="customize-view-dialog">
  @if (displayCustomizeTableView) {
    <app-customize-table-view
      [itemsRight]="this.optionalHeaders"
      [itemsLeft]="this.disabledHeaders"
      (updateRight)="this.optionalHeaders = $event"
      (updateLeft)="this.disabledHeaders = $event"
      (closeDialog)="updateLogView($event)"
    ></app-customize-table-view>
  }
</p-dialog>
<!-- #endregion -->

<!-- #region Add / View Weld Log Form -->
<p-dialog
  header="{{ dialogHeader }}"
  [style]="{ width: '95vw', height: '95vh', 'max-width': '1600px' }"
  [breakpoints]="{ '1200px': '96vw', '992px': '98vw', '768px': '100vw' }"
  [contentStyle]="{ overflow: 'auto' }"
  [(visible)]="displayLogForm"
  [modal]="true"
  [closeOnEscape]="true"
  [draggable]="false"
  [resizable]="false"
  [blockScroll]="false"
>
  @if (displayLogForm) {
    <app-add-edit-view-log
      [action]="actionLog"
      [draftBtn]="draftBtn"
      [dialogHeader]="dialogHeader"
      [dialogSubmit]="dialogSubmit"
      [userPermissions]="PERMISSIONS"
      [isViewEdit]="isViewEdit"
      [hideDraftBtn]="hideDraftBtn"
      [hideActionBtns]="hideActionBtns"
      [hideForContinuity]="hideForContinuity"
      [requiredFieldsLog]="requiredFieldsLog"
      [currentLog]="currentLog"
      (onCancel)="closeLogForm()"
      (onSuccess)="logSuccessOrFail($event)"
    ></app-add-edit-view-log>
  }
</p-dialog>
<!-- #endregion -->

<!-- #region Add / View Weld Log Form -->
<p-dialog
  header="Bulk Upload Weld Logs"
  [style]="{ width: '94%', height: '96%' }"
  [(visible)]="displayBulkUploadForm"
  [modal]="true"
  [closeOnEscape]="true"
  [draggable]="false"
  [resizable]="false"
  [blockScroll]="false"
  (onHide)="clearBulkUploadData()"
>
  <app-bulk-upload
    [requiredFieldsLog]="requiredFieldsLog"
    [refineryId]="bulkrefineryId"
    [refineryName]="bulkrefineryName"
    (onCancel)="openCloseBulkUploadDialog()"
    (onSuccess)="multipleLogsSuccessOrFail($event, 'add')"
  >
  </app-bulk-upload>
</p-dialog>

<!-- #endregion -->
<!-- #region Upload Weld Map Dialog -->
<p-dialog
  header="Upload Weld Map"
  [style]="{ width: '90vw', height: '90vh', 'max-width': '1400px' }"
  [contentStyle]="{ overflow: 'auto' }"
  [breakpoints]="{ '1200px': '95vw', '992px': '98vw', '768px': '100vw' }"
  [(visible)]="displayUploadWeldMapDialog"
  [modal]="true"
  [closeOnEscape]="true"
  [draggable]="false"
  [resizable]="false"
  [blockScroll]="false"
  (onHide)="clearUploadWeldMapData()"
>
  <div class="weld-map-dialog-body">
    @if (isWeldMapUploading || isCreatingWeldMapLogs) {
      <div class="weld-map-loading-overlay">
        <div class="weld-map-loader"></div>
        <div class="weld-map-loading-text">
          {{ isCreatingWeldMapLogs ? 'Creating weld logs...' : 'Extracting weld logs from PDF...' }}
        </div>
      </div>
    }

    <div class="row">
      <div class="col-12 col-lg-6">
        <label for="weldMapFile"> Select Weld Map PDF <span style="color: red">*</span> </label>

        <input #weldMapFileInput id="weldMapFile" type="file" class="form-control" accept=".pdf" (change)="onWeldMapFileSelected($event)" />

        @if (selectedWeldMapFileName) {
          <small class="text-success d-block mt-2"> Selected File: {{ selectedWeldMapFileName }} </small>
        }

        @if (uploadWeldMapErrorMessage) {
          <div class="text-danger mt-2">
            {{ uploadWeldMapErrorMessage }}
          </div>
        }
      </div>

      <div class="col-12 col-lg-6 alignRight weld-map-actions">
        <p-button class="mr-2" [disabled]="!selectedWeldMapFile || isWeldMapUploading || isCreatingWeldMapLogs" (onClick)="uploadWeldMap()">
          <em class="pi pi-cloud-upload mr-2"></em>
          {{ hasWeldMapExtraction ? 'Re-extract Weld Logs' : 'Extract Weld Logs' }}
        </p-button>

        @if (hasWeldMapExtraction && weldMapExtraction?.reviewRows?.length && !weldMapAllLogsCreated) {
          <p-button class="green-btn" [disabled]="weldMapInvalidLogCount > 0 || weldMapSelectedLogCount === 0 || isWeldMapUploading || isCreatingWeldMapLogs" (onClick)="createWeldMapLogs()">
            <em class="pi pi-plus-circle mr-2"></em>Create Weld Logs
          </p-button>
        }
      </div>
    </div>

    @if (hasWeldMapExtraction && weldMapExtraction) {
      <div class="weld-map-summary-cards mt-3">
        <div class="weld-map-summary-card">
          <span class="weld-map-summary-label">Total Welds</span>
          <span class="weld-map-summary-metric">
            <span class="weld-map-summary-icon total-icon"><em class="pi pi-link"></em></span>
            <span class="weld-map-summary-value">{{ weldMapTotalWeldCount }}</span>
          </span>
        </div>
        <div class="weld-map-summary-card review-card">
          <span class="weld-map-summary-label">Need Review</span>
          <span class="weld-map-summary-metric">
            <span class="weld-map-summary-icon review-icon"><em class="pi pi-exclamation-circle"></em></span>
            <span class="weld-map-summary-value">{{ weldMapNeedsReviewCount }}</span>
          </span>
        </div>
        <div class="weld-map-summary-card selected-card">
          <span class="weld-map-summary-label">Selected</span>
          <span class="weld-map-summary-metric">
            <span class="weld-map-summary-icon selected-icon"><em class="pi pi-check"></em></span>
            <span class="weld-map-summary-value">{{ weldMapSelectedLogCount }}</span>
          </span>
        </div>
      </div>

      @if (weldMapInvalidLogCount > 0) {
        <div class="weld-map-validation-banner mt-3">{{ weldMapInvalidLogCount }} extracted weld log{{ weldMapInvalidLogCount === 1 ? '' : 's' }} require validation before creation.</div>
      }

      <label class="weld-map-approve-header mt-3">
        <input
          type="checkbox"
          class="weld-map-approve-checkbox"
          [checked]="areAllWeldMapRowsSelected"
          [indeterminate]="areSomeWeldMapRowsSelected"
          [disabled]="!weldMapExtraction.reviewRows.length"
          (change)="toggleAllWeldMapRows($event)"
        />
        <span>Approve All</span>
      </label>

      @for (page of weldMapExtraction.pages; track $index) {
        <section class="weld-map-page mt-4">
          <h5>Page {{ page.pageNo }}</h5>
          @if (getWeldMapPageValidationMessage(page); as pageValidationMessage) {
            <div class="weld-map-page-warning">
              <em class="pi pi-exclamation-triangle"></em>
              <span>{{ pageValidationMessage }}</span>
            </div>
          }
          <div class="weld-map-page-metadata">
            <div>
              <label [for]="'weldMapEwo-' + $index"><strong>EWO Number</strong> <span class="text-danger">*</span></label>
              <input
                pInputText
                class="form-control"
                [id]="'weldMapEwo-' + $index"
                required
                [(ngModel)]="page.ewoNumber"
                (ngModelChange)="updateWeldMapPageMetadata(page)"
                [attr.aria-invalid]="isWeldMapMetadataMissing(page.ewoNumber)"
                [disabled]="isWeldMapUploading || isCreatingWeldMapLogs || weldMapAllLogsCreated"
              />
              @if (isWeldMapMetadataMissing(page.ewoNumber)) {
                <small class="weld-map-field-error">EWO Number is required.</small>
              }
            </div>
            <div>
              <label [for]="'weldMapDrawing-' + $index"><strong>Drawing Number</strong> <span class="text-danger">*</span></label>
              <input
                pInputText
                class="form-control"
                [id]="'weldMapDrawing-' + $index"
                required
                [(ngModel)]="page.drawingNumber"
                (ngModelChange)="updateWeldMapPageMetadata(page)"
                [attr.aria-invalid]="isWeldMapMetadataMissing(page.drawingNumber)"
                [disabled]="isWeldMapUploading || isCreatingWeldMapLogs || weldMapAllLogsCreated"
              />
              @if (isWeldMapMetadataMissing(page.drawingNumber)) {
                <small class="weld-map-field-error">Drawing Number is required.</small>
              }
            </div>
          </div>
          <div class="weld-map-table-wrapper mt-3">
            <table class="table table-sm weld-map-review-table">
              <thead>
                <tr>
                  <th>Approve</th>
                  <th>Weld Number</th>
                  <th>Weld ID</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                @for (weld of page.welds ?? []; track weld) {
                  <tr>
                    <td class="weld-map-validation-cell">
                      @if (getWeldMapReviewRow(weld); as row) {
                        <input
                          type="checkbox"
                          class="weld-map-approve-checkbox"
                          [attr.aria-label]="'Approve weld ' + weld.weldNumber + ' on page ' + page.pageNo"
                          [checked]="row.selected"
                          (change)="toggleWeldMapRow(row, $event)"
                        />
                        @if (getWeldMapRowDisplayErrors(row); as rowErrors) {
                          @if (rowErrors.length > 0) {
                            <div class="weld-map-invalid">{{ rowErrors.join(' ') }}</div>
                          }
                        }
                      }
                    </td>
                    @if (getWeldMapReviewRow(weld); as row) {
                      <td>
                        @if (row.editDraft; as draft) {
                          <input pInputText class="form-control" aria-label="Weld Number" [(ngModel)]="draft.weldNumber" />
                        } @else {
                          {{ weldMapDisplayValue(weld.weldNumber) }}
                        }
                      </td>
                      <td>
                        @if (row.editDraft; as draft) {
                          <input pInputText class="form-control" aria-label="Weld ID" [(ngModel)]="draft.weldID" />
                        } @else {
                          {{ weldMapDisplayValue(weld.weldID) }}
                        }
                      </td>
                      <td>
                        <div class="weld-map-row-actions">
                          @if (row.editDraft) {
                            <button
                              type="button"
                              pButton
                              icon="pi pi-check"
                              pTooltip="Save"
                              aria-label="Save weld"
                              [disabled]="isWeldMapUploading || isCreatingWeldMapLogs || weldMapAllLogsCreated"
                              (click)="saveWeldMapRow(page, weld)"
                            ></button>
                            <button type="button" pButton icon="pi pi-times" pTooltip="Cancel" aria-label="Cancel weld edit" (click)="cancelWeldMapRowEdit(weld)"></button>
                          } @else {
                            <button
                              type="button"
                              pButton
                              icon="pi pi-pencil"
                              pTooltip="Edit"
                              aria-label="Edit weld"
                              [disabled]="isWeldMapUploading || isCreatingWeldMapLogs || weldMapAllLogsCreated"
                              (click)="editWeldMapRow(weld)"
                            ></button>
                            <button
                              type="button"
                              pButton
                              icon="pi pi-trash"
                              pTooltip="Delete"
                              aria-label="Delete weld"
                              [disabled]="isWeldMapUploading || isCreatingWeldMapLogs || weldMapAllLogsCreated"
                              (click)="deleteWeldMapRow(page, weld)"
                            ></button>
                          }
                        </div>
                      </td>
                    }
                  </tr>
                } @empty {
                  <tr>
                    <td colspan="4" class="weld-map-empty-state">No weld records found on this page.</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </section>
      }
    } @else if (weldMapExtraction) {
      <div class="weld-map-empty-state mt-4">No pages were extracted from the weld map.</div>
    }

    @if (weldMapProcessingSummary && weldMapExtraction) {
      <div class="weld-map-results mt-4">
        <h5>Processing Results</h5>

        <div class="mt-2">
          <span class="mr-3"><strong>Total Selected:</strong> {{ weldMapSubmittedCount }}</span>
          <span class="mr-3"><strong>Created:</strong> {{ weldMapProcessingSummary.successful.length }}</span>
          <span class="mr-3"><strong>Failed:</strong> {{ weldMapProcessingSummary.unsuccessful.length }}</span>
        </div>

        <div class="row mt-3">
          <div class="col-12 col-xl-6 mb-3 mb-xl-0">
            <div class="weld-map-results-panel success-panel">
              <h6>Successfully Created Weld Logs</h6>
              @if (weldMapProcessingSummary.successful.length > 0) {
                <table class="table table-sm weld-map-results-table">
                  <thead>
                    <tr>
                      <th>Weld Log</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (item of weldMapProcessingSummary.successful; track item.identifier) {
                      <tr>
                        <td>{{ item.identifier }}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              } @else {
                <div class="weld-map-empty-state">No weld logs were created.</div>
              }
            </div>
          </div>

          <div class="col-12 col-xl-6">
            <div class="weld-map-results-panel failure-panel">
              <h6>Unsuccessful Weld Logs</h6>
              @if (weldMapProcessingSummary.unsuccessful.length > 0) {
                <table class="table table-sm weld-map-results-table">
                  <thead>
                    <tr>
                      <th>Weld Log</th>
                      <th>Failure Reason</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (item of weldMapProcessingSummary.unsuccessful; track item.identifier + item.reason) {
                      <tr>
                        <td>{{ item.identifier }}</td>
                        <td>{{ item.reason || 'Creation failed.' }}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              } @else {
                <div class="weld-map-empty-state">No failures were reported.</div>
              }
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</p-dialog>
<!-- #endregion Upload Weld Map Dialog -->
<!-- #region Clone Log dialog-->
<p-dialog header="Clone Weld Log" [(visible)]="displayCloneDialog" [modal]="true" [closeOnEscape]="true" [draggable]="false" [resizable]="true" [style]="{ 'min-height': '0px', width: '18%' }">
  <div class="row">
    <label for="amountToClone">Number of Clones<span style="color: red">*</span></label>
    <div class="col-12">
      <input
        class="formInput"
        placeholder="Enter a number 1-20"
        pInputText
        (keypress)="keyValidation.numeric($event)"
        [(ngModel)]="amountToClone"
        name="amountToClone"
        maxlength="2"
        oninput="if (this.value.length > this.maxlength) this.value = this.value.slice(0, this.maxlength);"
      />
    </div>
  </div>

  <div class="row">
    <div class="col-12 alignRight">
      <p-button (onClick)="cloneWeldLog()"><em class="pi pi-clone mr-2"></em>Clone</p-button>
      <p-button class="ml-2 red-btn" (onClick)="closeCloneDialog()" id="cancelButton"><em class="pi pi-times-circle mr-2"></em>Cancel</p-button>
    </div>
  </div>
</p-dialog>
<!-- #endregion -->

<!-- #region Create Repair Log dialog-->
<p-dialog header="Clone Weld Log" [(visible)]="displayRepairDialog" [modal]="true" [closeOnEscape]="true" [draggable]="false" [resizable]="true" [style]="{ 'min-height': '0px', width: '19%' }">
  <div class="row">
    <label>New Weld Modifier<span style="color: red">*</span></label>
    <div class="col-12">
      <input
        class="formInput"
        placeholder="Enter new Weld Modifier"
        pInputText
        (keypress)="keyValidation.alphaUpperCaseNoSpace($event)"
        [(ngModel)]="this.newWeldModifierText"
        (ngModelChange)="this.newWeldModifierText = $event.toUpperCase()"
      />
    </div>
  </div>

  <div class="row">
    <div class="col-12 alignRight">
      <p-button (onClick)="repairWeldLog()"><em class="pi pi-cog mr-2"></em>Create Repair</p-button>
      <p-button class="ml-2 red-btn" (onClick)="closeRepairWeldLogDialog()" id="cancelButton"><em class="pi pi-times-circle mr-2"></em>Cancel</p-button>
    </div>
  </div>
</p-dialog>
<!-- #endregion -->

<!-- #region Table -->
<p-contextMenu #cm [model]="contextMenuItems" [style]="{ 'white-space': 'nowrap', width: 'auto', 'min-width': '10em' }"></p-contextMenu>
<p-table
  #weldLogTable
  [value]="weldLogData"
  [scrollable]="true"
  [paginator]="true"
  paginatorPosition="both"
  paginatorDropdownAppendTo="body"
  [rows]="10"
  scrollDirection="both"
  [rowsPerPageOptions]="[10, 25, 50, 100]"
  selectionMode="multiple"
  [(selection)]="this.selectedLogs"
  (onContextMenuSelect)="setContextMenu($event)"
  [contextMenu]="cm"
  [metaKeySelection]="true"
  dataKey="weldLogId"
>
  <!-- #region Headers -->
  <ng-template pTemplate="header" let-columns>
    <tr>
      <!-- #region Default Headers -->
      @for (header of defaultHeaders; track header; let i = $index) {
        <th id="head{{ header.width }}" class="header" [ngStyle]="{ width: header.width }" [pSortableColumn]="header.field">
          {{ header.header }}
          <p-sortIcon [field]="header.field"></p-sortIcon>
        </th>
      }
      <!-- #endregion -->

      <!-- #region Optional Headers -->
      @for (header of optionalHeaders; track header; let i = $index) {
        <th id="head{{ header.width }}" class="header" [ngStyle]="{ width: header.width }" [pSortableColumn]="header.field">
          {{ header.header }}
          <p-sortIcon [field]="header.field"></p-sortIcon>
        </th>
      }
      <!-- #endregion -->
    </tr>
  </ng-template>
  <!-- #endregion -->

  <!-- #region Content Data -->
  <!--Fill data if column is enabled-->
  <ng-template id="tableRows" pTemplate="body" let-log let-columns="headers" let-rowIndex="rowIndex">
    <tr [pSelectableRow]="log" [pSelectableRowIndex]="rowIndex" [pContextMenuRow]="log">
      <!-- #region Table Data -->
      @for (header of defaultHeaders; track header) {
        @if (header.field != 'weldNo') {
          <td [ngStyle]="{ width: header.width }" [ngClass]="{ purple: verifyQADates(log) }">
            {{ log[header.field] }}
          </td>
        }
        @if (header.field == 'weldNo' && log.weldModifier !== null) {
          <td [ngStyle]="{ width: header.width }" [ngClass]="{ purple: verifyQADates(log) }">{{ log[header.field] }}-{{ log.weldModifier }}</td>
        }
        @if (header.field == 'weldNo' && log.weldModifier == null) {
          <td [ngStyle]="{ width: header.width }" [ngClass]="{ purple: verifyQADates(log) }">
            {{ log[header.field] }}
          </td>
        }
      }

      @for (header of optionalHeaders; track header) {
        @if (header.field != 'entryStatus' && header.field != 'acceptReject' && header.field != 'rtPercentage') {
          <td [ngStyle]="{ width: header.width }" [pTooltip]="log[header.qaTypeDate]" tooltipPosition="top">
            {{ log[header.field] }}
          </td>
        }
        @if (header.field == 'entryStatus' && log[header.field] === 'Draft') {
          <td [ngStyle]="{ width: header.width }" class="red">
            {{ log[header.field] }}
          </td>
        }
        @if (header.field == 'entryStatus' && log[header.field] !== 'Draft') {
          <td [ngStyle]="{ width: header.width }">
            {{ log[header.field] }}
          </td>
        }
        @if (header.field == 'acceptReject' && log[header.field] === 'Rejected' && log.QAType_REP == undefined) {
          <td [ngStyle]="{ width: header.width }" class="orange">
            {{ log[header.field] }}
          </td>
        }
        @if ((header.field == 'acceptReject' && log[header.field] !== 'Rejected') || (log[header.field] === 'Rejected' && log.QAType_REP != undefined)) {
          <td [ngStyle]="{ width: header.width }">
            {{ log[header.field] }}
          </td>
        }
        @if (header.field == 'rtPercentage' && log[header.field] != null) {
          <td [ngStyle]="{ width: header.width }">{{ log[header.field] }}%</td>
        }
        @if (header.field == 'rtPercentage' && log[header.field] == null) {
          <td [ngStyle]="{ width: header.width }">
            {{ log[header.field] }}
          </td>
        }
      }
      <!-- #endregion -->
    </tr>
  </ng-template>
  <!-- #endregion -->
</p-table>
<!-- #endregion -->

<!-- #region Delete Log dialog-->
<p-dialog
  header="{{ deleteDialogHeader }}"
  [(visible)]="displayDeleteDialog"
  [modal]="true"
  [closeOnEscape]="true"
  [draggable]="false"
  [resizable]="true"
  [style]="{ 'min-height': '0px', width: '20%' }"
>
  <div class="row">
    <div class="col-12">
      <label for="deleteReason">Reason for deletion</label>
      <textarea name="deleteReason" id="deleteReason" type="text" pInputText maxlength="500" rows="2" [(ngModel)]="reasonForDeletion" class="formInput form-control"> </textarea>
    </div>
  </div>

  <div class="row">
    <div class="col-12 alignRight">
      @if (selectedLogs == undefined || selectedLogs.length <= 1) {
        <p-button class="mr-2 red-btn" (onClick)="deleteLog()"><em class="pi pi-trash mr-2"></em>Delete</p-button>
      }
      @if (selectedLogs != undefined && selectedLogs.length > 1) {
        <p-button class="mr-2 red-btn" (onClick)="deleteMultipleLogs()"><em class="pi pi-trash mr-2"></em>Delete</p-button>
      }
      <p-button (onClick)="closeDeleteDialog()" id="cancelButton"><em class="pi pi-times-circle mr-2"></em>Cancel</p-button>
    </div>
  </div>
</p-dialog>
<!-- #endregion -->

<!-- #region Add QA Type dialog-->
@if (displayEditQATypeDialog) {
  <div>
    <p-dialog
      header="{{ qaTypeDialogHeader }}"
      [(visible)]="displayEditQATypeDialog"
      [modal]="true"
      [closeOnEscape]="true"
      [draggable]="false"
      [resizable]="true"
      [style]="{ 'min-height': '0px', width: '40%' }"
    >
      <app-edit-multiple-qa-types [action]="0"></app-edit-multiple-qa-types>
      <div class="row">
        <div class="col-12 alignRight">
          @if (selectedLogs != undefined && selectedLogs.length > 1) {
            <p-button (onClick)="editMultipleQATypesAndDates()"> <em class="pi pi-cog mr-2"></em>Add QA Type</p-button>
          }
          <p-button class="ml-2 red-btn" (onClick)="closeQATypeDialog()" id="cancelButton"><em class="pi pi-times-circle mr-2"></em>Cancel</p-button>
        </div>
      </div>
    </p-dialog>
  </div>
}
<!-- #endregion -->

@if (displayEditQADateDialog) {
  <div>
    <p-dialog
      header="{{ qaDateDialogHeader }}"
      [(visible)]="displayEditQADateDialog"
      [modal]="true"
      [closeOnEscape]="true"
      [draggable]="false"
      [resizable]="true"
      [style]="{ 'min-height': '0px', width: '45%' }"
    >
      <app-edit-multiple-qa-types [action]="0" [showCalendar]="1"></app-edit-multiple-qa-types>
      <div class="row">
        <div class="col-12 alignRight">
          @if (selectedLogs != undefined && selectedLogs.length > 1) {
            <p-button (onClick)="editMultipleQATypesAndDates()"> <em class="pi pi-cog mr-2"></em>Add QA Dates</p-button>
          }
          <p-button class="ml-2 red-btn" (onClick)="closeQADateDialog()" id="cancelButton"><em class="pi pi-times-circle mr-2"></em>Cancel</p-button>
        </div>
      </div>
    </p-dialog>
  </div>
}
<!-- #endregion -->

<!-- #Region Add Stamp Processs -->
@if (displayEditProcessDialog) {
  <div>
    <p-dialog
      header="{{ processDialogHeader }}"
      [(visible)]="displayEditProcessDialog"
      [modal]="true"
      [closeOnEscape]="true"
      [draggable]="false"
      [resizable]="true"
      [style]="{ 'min-height': '0px', width: '45%' }"
    >
      <app-edit-multiple-processes [action]="0" [showAcceptReject]="0"></app-edit-multiple-processes>
      <div class="row">
        <div class="col-12 alignRight">
          @if (selectedLogs != undefined && selectedLogs.length > 1) {
            <p-button (onClick)="editMultipleProcesses()"> <em class="pi pi-cog mr-2"></em>Add Welder</p-button>
          }
          <p-button class="ml-2 red-btn" (onClick)="closeProcessDialog()" id="cancelButton"><em class="pi pi-times-circle mr-2"></em>Cancel</p-button>
        </div>
      </div>
    </p-dialog>
  </div>
}

@if (displayEditAcceptRejectDialog) {
  <div>
    <p-dialog
      header="{{ acceptRejectDialogHeader }}"
      [(visible)]="displayEditAcceptRejectDialog"
      [modal]="true"
      [closeOnEscape]="true"
      [draggable]="false"
      [resizable]="true"
      [style]="{ 'min-height': '0px', width: '45%' }"
    >
      <app-edit-multiple-processes [action]="0" [showAcceptReject]="1"></app-edit-multiple-processes>
      <div class="row">
        <div class="col-12 alignRight">
          @if (selectedLogs != undefined && selectedLogs.length > 1) {
            <p-button (onClick)="editMultipleProcesses()"> <em class="pi pi-cog mr-2"></em>Add Accept/Reject</p-button>
          }
          <p-button class="ml-2 red-btn" (onClick)="closeAcceptRejectDialog()" id="cancelButton"><em class="pi pi-times-circle mr-2"></em>Cancel</p-button>
        </div>
      </div>
    </p-dialog>
  </div>
}
<!-- #endregion -->

<!-- #region 'Edit Multiple Logs dialog' -->
<p-dialog
  header="Edit Multiple Logs"
  [style]="{ width: '35%', height: 'auto' }"
  [(visible)]="displayEditMultipleLogsForm"
  [modal]="true"
  [closeOnEscape]="true"
  [draggable]="false"
  [resizable]="false"
  [blockScroll]="false"
>
  @if (displayEditMultipleLogsForm) {
    <app-edit-multiple-logs
      [userPermissions]="PERMISSIONS"
      [hideActionBtns]="hideActionBtns"
      [selectedLogs]="selectedLogs"
      [requiredFieldsLog]="requiredFieldsLog"
      (onCancel)="closeEditMultipleLogsForm()"
      (onSuccess)="multipleLogsSuccessOrFail($event, 'update')"
    ></app-edit-multiple-logs>
  }
</p-dialog>
<!-- #endregion 'Edit Multiple Logs dialog' -->

<p-dialog
  header="Send NDEs to QMDB"
  [style]="{ width: '35%', minHeight: '20%' }"
  [(visible)]="displaySendNDEForm"
  [modal]="true"
  [closeOnEscape]="true"
  [draggable]="false"
  [resizable]="false"
  [blockScroll]="false"
>
  @if (displaySendNDEForm) {
    <app-create-nde [userPermissions]="PERMISSIONS" [hideActionBtns]="hideActionBtns" [selectedLogs]="selectedLogs" (onCancel)="closeSendNDEForm()"></app-create-nde>
  }
</p-dialog>

<!-- #region 'Custom Confirm Notification' -->
<p-toast [style]="{ marginTop: '40px !important' }" key="confirm" [baseZIndex]="6000" position="center">
  <ng-template let-message pTemplate="message">
    <div class="flex flex-column" style="flex: 1">
      <div class="text-center">
        <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
        <h4>{{ message.summary }}</h4>
        <p>{{ message.detail }}</p>
      </div>
      <div class="grid p-fluid">
        <div class="col-6">
          <button type="button" pButton (click)="onConfirm()" label="Yes" class="p-button-success"></button>
        </div>
        <div class="col-6">
          <button type="button" pButton (click)="onReject()" label="No" class="p-button-secondary"></button>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>
<!-- #endregion 'Custom Confirm Notification' -->
